import { Injectable, Type } from '@angular/core';

import { ExportSettingsComponent } from '../components/panels/export-settings/export-settings.component';
import { FeedAlertsComponent } from '../components/panels/feed-alerts/feed-alerts.component';
import { FeedAlgorithmsComponent } from '../components/panels/feed-algorithms/feed-algorithms.component';
import { FeedQueryEditorComponent } from '../components/panels/feed-query-editor/feed-query-editor.component';
import { FiltersComponent } from '../components/panels/filters/filters.component';
import { PaneInfoComponent } from '../components/panels/pane-info/pane-info.component';
import { SchedulesComponent } from '../components/panels/schedules/schedules.component';
import { SearchBuilderWrapperComponent } from '../components/search-builder-wrapper/search-builder-wrapper.component';
import { SidebarPanelComponent } from '../components/sidebar-panel/sidebar-panel.component';
import { WidgetSidebarComponent } from '../components/panels/widget-sidebar/widget-sidebar.component';

@Injectable({
  providedIn: 'root',
})
export class PanelComponentMappingService {
  private componentMap: { [key: string]: Type<any> } = {
    SearchBuilderWrapperComponent: SearchBuilderWrapperComponent,
    WidgetSidebarComponent: WidgetSidebarComponent,
    FiltersComponent: FiltersComponent,
    QueryEditorComponent: FeedQueryEditorComponent,
    ExportComponent: ExportSettingsComponent,
    AlertsComponent: FeedAlertsComponent,
    SchedulesComponent: SchedulesComponent,
    AlgorithmsComponent: FeedAlgorithmsComponent,
    PaneInfoComponent: PaneInfoComponent,
  };

  private childComponentInstance: SidebarPanelComponent | null = null;

  setChildInstance(instance: SidebarPanelComponent) {
    this.childComponentInstance = instance;
  }

  getChildInstance(): SidebarPanelComponent | null {
    return this.childComponentInstance;
  }

  getComponentType(componentName: string): Type<any> | null {
    return this.componentMap[componentName] || null;
  }
}
